// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.90.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body,
#root {
  height: 100%;
  background: #f0f4f8;
  width: 100%;
  overflow: hidden;
  font-family: 'Microsoft YaHei', '微软雅黑', sans-serif;
}
.slb-kh-add-popup .adm-popup-body .userInfo .Form .adm-list-card .adm-list-item {
  margin-top: 1rem;
  background-color: #f4f7fd;
  border-radius: 1rem;
  min-height: 2rem;
  height: auto;
}
input[readonly] {
  background-color: #efefef;
  color: #1677ff !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles.less"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AACF;AAEA;;;EAGE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kDAAA;AAAF;AAGA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AADF;AAIA;EACE,yBAAA;EACA,yBAAA;AAFF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  background: #f0f4f8;\n  width: 100%;\n  overflow: hidden;\n  font-family: 'Microsoft YaHei', '微软雅黑', sans-serif;\n}\n\n.slb-kh-add-popup .adm-popup-body .userInfo .Form .adm-list-card .adm-list-item {\n  margin-top: 1rem;\n  background-color: #f4f7fd;\n  border-radius: 1rem;\n  min-height: 2rem;\n  height: auto;\n}\n\ninput[readonly] {\n  background-color: #efefef;\n  color: #1677ff !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
